import React, { useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import LatestNews from "../Dashboard/LatestNews";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventsRequest } from "../../../store/features/actions/eventsActions";
import { useUser } from "../../../context/UserContext";
import { AccountListContext } from "../../../context/AccountListContext";

function EventsWrappers(props) {
  const { allAccounts } = useContext(AccountListContext);
  const { user } = useUser();
  const { account_info } = useSelector(state=>state?.accountsReducer);
  const { currentPage, perPage, sortField, sortOrder, filter } = props;
  const dispatch = useDispatch();
  const pathName = useLocation().pathname;
  const isDashboard = pathName === "/dashboard";

  const all_company_names = useMemo(() => allAccounts?.map((item) => item?.name), [allAccounts]);

  const client_company = useMemo(() => {
    return user?.client_profile_company_name ? [user.client_profile_company_name] : [];
  }, [user]);

  const all_companies = useMemo(() => [...all_company_names, ...client_company], [all_company_names, client_company]);

  useEffect(() => {
    const fetchEvents = (params) => {
      dispatch(fetchEventsRequest(params));
    };

    if (isDashboard) {
      const params = {
        client_name: user?.client_profile_company_name || "",
        client_code: user?.client_profile_company_code || "",
        companies: all_companies,
        regions: "",
        types: "",
        page: currentPage,
        limit: perPage,
        sort_by: sortField,
        sort_order: sortOrder,
        ...filter,
      };
      fetchEvents(params);
    } else {
      const client_code = account_info?.db_details["client_code"];
      const client_name = account_info?.db_details["client_name"];
      const account_code = account_info?.db_details["account_code"];
      const account_name = account_info?.db_details["account_name"];

      if (account_name) {
        const params = {
          client_name,
          client_code,
          account_name,
          account_code,
          regions: "",
          types: "",
          page: currentPage,
          limit: perPage,
          sort_by: sortField,
          sort_order: sortOrder,
          ...filter,
        };
        fetchEvents(params);
      }
    }
  }, [currentPage, perPage, sortField, sortOrder, filter, account_info, all_companies, isDashboard, user, dispatch]);

  return isDashboard ? <LatestNews /> : '';
}

export default EventsWrappers;